import { Link } from "react-router-dom";
import type { Provider } from "@/types";
import { ProviderIcon } from "@/components/ProviderIcon";
import { cn } from "@/lib/utils";

export function ProviderTile({
  provider,
  modelCount,
  className,
}: {
  provider: Provider;
  modelCount: number;
  className?: string;
}) {
  return (
    <Link
      to={`/providers/${provider.id}`}
      className={cn("card group", className)}
    >
      <div className="card-head">
        <ProviderIcon provider={provider} size={28} className="card-avatar-img" />
        <div className="min-w-0">
          <h3 className="truncate">{provider.name}</h3>
          <div className="mt-0.5 font-mono text-[0.62rem] text-[color:var(--faint)]">
            {provider.id}
          </div>
        </div>
      </div>
      <p>{provider.description}</p>
      <div className="meta">
        <span>{modelCount} models</span>
        <span className="arrow">Open →</span>
      </div>
    </Link>
  );
}
